import React from 'react'
import { Input as UIInput } from '@/components/ui/input'
import { cn } from '@/lib/utils'

class Input extends React.Component {

  inputRef = React.createRef()

  // Some callers attach string refs to this wrapper (e.g. dropdown_menu's
  // ref="search"); expose value/focus so instance access keeps working.
  get value() {
    return this.inputRef.current ? this.inputRef.current.value : undefined
  }

  focus() {
    if (this.inputRef.current) {
      this.inputRef.current.focus()
    }
  }

  onChange = () => {
    this.props.onChange(this.inputRef.current.value)
  }

  render() {
    // Strip the legacy bootstrap default; anything else passes through.
    const classes = (this.props.className || '')
      .split(/\s+/)
      .filter((token) => token && token !== 'form-control')

    return (
      <UIInput
        ref={this.inputRef}
        type={this.props.type || 'text'}
        className={cn(classes, this.props.highlighted && 'border-ring ring-3 ring-ring/30')}
        placeholder={this.props.placeholder || ''}
        value={this.props.value}
        onChange={this.onChange}
        onFocus={this.props.onFocus}
      />
    )
  }
}

export default Input
